import { render, staticRenderFns } from "./PropertyItem.vue?vue&type=template&id=e9c1b4c0&"
import script from "./PropertyItem.vue?vue&type=script&lang=js&"
export * from "./PropertyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports